<template>
    <div>
        <h5>Edicion de Contenido</h5>
        <hr />
        <div v-on="obtenerInicializarFormulario ?this.inicializarFormulario():this.noHacerNada()" >
            <div >
            <PaginaDeInicio :prefijo="1"
            v-on:valorParaElPadre="cambioTipoDePagina" 
            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
            :parametros="{3: null,MenuId: null,SubmenuId: null,TipoContenedorId: null,ConPaginaDeInicio: false,ConMenu: false,ConSubmenu: false, ConSecciones: false, ConInactivas:false, SoloPermiteSubirContenido: true}" 
            :valorDefinido="valorDefinidoMicrositio" 
            :idDelInput="'MicrositioId'" 
            :key="idKey"></PaginaDeInicio>
            <br>
            </div>
        <div>
             <select id="tipo-menu" @change="cambiarTipoDeMenu($event)" v-model="idDelModelo" class="form-control" >
                 <option value="-1" >Seleccione Tipo de Menu</option>
                <option value="1">Menu Principal</option>        
                 <option value="2">Sitio De Interes</option>
            </select> 
            <br>
</div>


            <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[menuEsDescarga?'active':'' ]" @click="menuEsDescarga=true;menuConSubmenus=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Es Descarga
                        </label>
                        <label class="btn btn-secondary" :class="[!menuEsDescarga?'active':'' ]"  @click="menuEsDescarga=false">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >No es Descarga
                        </label>

                    
                     <hr/>
            </div><br><br> 
             <div v-if="!menuEsDescarga" class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[menuConSubmenus?'active':'' ]" @click="menuConSubmenus=true">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Con Submenus
                        </label>
                        <label class="btn btn-secondary" :class="[!menuConSubmenus?'active':'' ]"  @click="menuConSubmenus=false">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >Sin Submenus
                        </label>

                    <br> 
                     <hr/>
                     <br><br>
            </div>
           
            <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons" v-if="menuEsDescarga">
                        <label class="btn btn-secondary" :class="[!visualizarEnVisor?'active':'' ]" @click="visualizarEnVisor=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Descargar Directamente
                        </label>
                        <label class="btn btn-secondary" :class="[visualizarEnVisor?'active':'' ]"  @click="visualizarEnVisor=true">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >Visualizar en Visor
                        </label>

                    <br> 
                     <hr/>
            </div><br><br>

                    <div >
                      <h6>Ingrese un titulo del menu</h6>
                    <input v-model="menuTitulo" type="text" id="texto_vinculo_contenido" :class="'form-control'" placeholder="Ingrese titulo del Menu" />
                   </div><br>


            <div v-if="!menuEsDescarga &&  !menuConSubmenus">
                <h6>Ingrese Ruta del Vinculo o Pagína {{menuConSubmenus}}</h6>
                <input v-model="menuRutaVinculoPagina" class="form-control" type="text" id="titulo_contenido" :class="[!this.campoEsValidoFormulario(titulo) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el título" />
                <hr />
            </div>

        <div v-if="menuEsDescarga">
                <div v-if="vinculoParaArchivo==false" class="btn-group btn-group-toggle elementos-archivos-contenido" data-toggle="buttons">
                    <label :class="[descargaArchivoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="descargaArchivoRadio=true, vinculoArchivoRadio=false">
                        <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo de descarga
                    </label>
                    <label :class="[vinculoArchivoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="vinculoArchivoRadio=true, descargaArchivoRadio=false,limpiarArchivo()">
                        <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo del archivo
                    </label>
                </div><br>
            
                <div >
                     <div class="form-inline" v-if="menuVinculo != null"><h6>Archivo Actual</h6>&nbsp;&nbsp;
              <a class="btn btn-success" :href="descargarArchivo(menuVinculo)"><i class="fas fa-download"></i></a><br>
              &nbsp;&nbsp; 
               <button  class="btn btn-success" v-on:click="AbreElVisor(menuVinculo)"><i class="fas fa-eye"></i></button>
               </div> <br>
                    <!-- <input type="text" disabled :value="archivoActual" class="form-control"> -->
                    <h6>Seleccione el archivo de descarga</h6>
                    <input type="file" id="descarga_contenido" ref=""  v-on:change="subirArchivoDescarga($event)" accept=".PDF,.XLSX,.XLSB,.ZIP" />
                </div> <br>
                 <div v-if="vinculoArchivoRadio">
                    <h6>Ingrese el vínculo(URL)</h6>
                    <input v-model="menuVinculo" type="text" id="vinculo_contenido" placeholder="Ingrese el vínculo" />
                </div>

          </div>  
                                            
        </div>

            <!-- <div >
                <h6 >Ingrese fecha de publicación</h6>
                <div style="display: flex;">
                    <div style="display: flex; align-items: center;">
                        <h6 v-if="urgenteRadio" style="margin-right: 5px;">Inicio </h6>
                        <datepicker :key="'dtPkInicio'" 
                                    :format="DatePickerFormato"  
                                    :highlighted="highlighted_DtPkInicio"
                                    :disabled-dates="disabledDates_DtPkInicio" 
                                    v-model="fechaDatePickerInicio"
                                    @selected="seleccionDeFechaDtPkInicio"  
                                    :value="this.fechaDefaultDtPkInicio" 
                                    :bootstrap-styling="true"
                                    :calendar-button="true"
                                    calendar-button-icon="far fa-calendar-alt" 
                                    name="fecha" 
                                    :language="languaje"></datepicker>
                    </div>
                    <div v-if="urgenteRadio" style="display: flex; align-items: center;">
                            <h6 style="margin-right: 5px;">Fin </h6>
                            <datepicker :key="'dtPkFin'" 
                                        :format="DatePickerFormato"  
                                        :highlighted="highlighted_DtPkFin"
                                        :disabled-dates="disabledDates_DtPkFin" 
                                        v-model="fechaDatePickerfinal"
                                        @selected="seleccionDeFechaDtPkFin"  
                                        :value="this.fechaDefaultDtPkFinal" 
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="far fa-calendar-alt"  
                                        :class="{'texto-negro': true}" name="fecha" 
                                        :language="languaje"></datepicker>
                    </div>
                </div>
                <hr />
            </div>   -->
            
            <div>
                <div>                  
                </div>
            </div>
            <div class="text-right">
                <div>
                    <button type="button" class="btn btn-primary" @click="editarMenuMicrositio"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                   <button type="button" class="btn btn-primary" @click="cancelarEdicion"><i class="fas fa-window-close"></i>&nbsp;&nbsp;Cancelar</button>

                </div>
                
            </div>    
        </div>
   
</template>
<script>

import api from '@/../static/js/api'
import axios from 'axios'
import comun from "@/../static/js/comun"
import moment from 'moment';
import enumeraciones from '@/../static/js/enumeraciones'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import C006Submenus from '../../Catalogos/C006Submenus.vue'
import Datepicker from 'vuejs-datepicker';
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
import CListaDeImagenes from '../../Comun/CListaDeImagenes.vue'
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import PaginaDeInicio from "@/components/SICPO/Catalogos/C001PaginaInicio.vue"

export default {
     props:{
         menuMicrositio:Object
            },
    
    directives: {
        tooltipF
    },
//declaracion de variables 
    data() {
        return {
          nuevoMenuMicrositio:{
              MicrositioId:0,
              TipoMenu:0
          },
          idKey:1,
          idDelModelo:-1,
          valorDefinidoMicrositio:-1,
          menuEsDescarga:true,
          menuTitulo:null,
          menuRutaVinculoPagina:null,
          menuVinculo:null,
          menuConSubmenus:null,
            mostrarImagenActual:false,
            idDeContenidoMicrositio:0,
           imagenActual:null,
           archivoActual:null,
           mostrarUltimaColumna:0,
           formatoId:null,
            fechaDatePickerInicio: null,
            fechaDatePickerfinal: new Date(),
            fechaSeleccionada: 0,
            fechaDefaultDtPkInicio: new Date(),
            fechaDefaultDtPkFinal: new Date(),
            DatePickerFormato: 'yyyy-MM-dd',
            languaje:{
                language: 'es',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                rtl: false,
                ymd: 'yyyy-MM-dd',
                yearSuffix: ''
            },
            highlighted_DtPkInicio: {
                customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaFin = this.obtenerFecha(this.fechaDatePickerfinal);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(this.informativoRadio) {
                        if(diasDeMes == fechaInicio) {
                            return true
                        }
                    }
                    else if(this.urgenteRadio) {
                        if(diasDeMes >= fechaInicio && diasDeMes <= fechaFin) {
                             return true
                        }
                    }
                },
                includeDisabled: false
            },
            highlighted_DtPkFin: { 
                customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaFin = this.obtenerFecha(this.fechaDatePickerfinal);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(diasDeMes >= fechaInicio && diasDeMes <= fechaFin) {
                        return true
                    }
                },
                includeDisabled: false
            },
            disabledDates_DtPkInicio: {
                 customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaActual = this.obtenerFecha(new Date());
                    if(diasDeMes < fechaActual)
                        return true
                }
            },
            disabledDates_DtPkFin: {
                 customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(diasDeMes < fechaInicio){
                        return true
                    }
                }
            },
            enumeraciones,
            textoDelContenido: null,
            vinculoParaArchivo:false,
            IMAGEN_CONTENIDO: null,
            ARCHIVO_DESCARGA: null,
            mostrarSubidorDeArchivos: false,
            esImagen:true,
            esTexto:false,
            esComunicado:false,
            visualizarEnVisor:false,
            EsLink:false,
            tituloComunicado:null,
            tituloCarruselYTexto:null,
            textoDelContenidoCarrusel:null,
            tituloContacto:null,
            descripcionContacto:null,
            numeroDeColumnas:[],
            rutaVinculo:null,
            fechaDePublicacion: '',
            fechaDePublicacionFin: '',
            titulo: '',
            tituloCarrusel:null,
            textoVinculo: null,
            textoVinculoArchivo: null,
            textoVinculoPrincipal: null,
            rutaVideo:null,          
            contenidoConListaDeArchivos:false,
            vinculo: null,
            tituloArchivo: null,
            nombrePresidente: null,
            rangoPresidente: null,
            textoMensajeCampoFaltante:'',
            mostrarErroresInput: false,
            existePerdidaDeCambios: false,
            descargaRadio: false,
            vinculoRadio: false,
            textoBotonAgregaraAoV: 'Archivo',
            descargaArchivoRadio: true,
            vinculoArchivoRadio: false,
            vinculoArchivo: null,
            urgenteRadio: false,
            informativoRadio: false,
            sobreescribirArchivo: false,
            listaDeArchivos: [],
            listaDeArchivosBit:new Object(),
            contadorArchivos: 0,
            opcionVaciarListaArchivos: false,
            disposicionEspecial: false,
            esPin: false,
            textoTituloSubmenu: null,
            textoEsComunicado: 'Si esta opción es seleccionada este archivo se mostrará en la página principal del Micrositio con la imagen seleccionada',
            textoVisualizarEnVisor: 'Si esta opción es seleccionada este archivo se podra visualizar antes de poder descargar',
            textoEsImagen:'Si esta opción es seleccionada tendra que agregar una imagen para el carrusel',
            textoEsLink:'Si esta opción es seleccionada podra ingresar un link a una página exterior',
            imagenDeObligacion: null,
            SERVIDOR_LOCAL:'//themisfs/'
        }
    },
    components: {
        C006Submenus,
        Datepicker,
        CSelectGenerico,
        CListaDeImagenes,
        PaginaDeInicio
    },
    methods: {
        cambiarTipoDeMenu:function(evento){
            this.nuevoMenuMicrositio.TipoMenu = evento.target.value
        },
        cambioTipoDePagina:function(evento){
            this.nuevoMenuMicrositio.MicrositioId = evento.target.value;

        },
AbreElVisor: function(vinculo) {
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
descargarArchivo: function(vinculo) {
  var ejecucion=null;
  if(vinculo != null){
    var rutaArchivo =vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,this.SERVIDOR_LOCAL);
    ejecucion =api.conexion+api.Comun.funcion.DescargarArchivo+'?'+'rutaDelArchivo='+vinculo;
  }
 return ejecucion;
 },

cancelarEdicion:function(){
     this.evtOcultaFormulario(false);
},

evtOcultaFormulario(EsEdicion){
    let opciones={ocultarFormulario:false,esEdicion:EsEdicion}
    this.$emit('OcultarFormulario',opciones);
},

             limpiarArchivo:function(){
           
                    this.ARCHIVO_DESCARGA = null;
                    this.vinculo=null;
                    this.mostrarSubidorDeArchivos = false;
                    

        },


valoresDeColumnas:function(){
 let numColumnas = this.numeroDeColumnas.length;
                let textoFinal='';

                for(var aux=0; aux< numColumnas;aux++){
                    textoFinal = textoFinal.concat(this.numeroDeColumnas[aux],'/');
                }
},
       
         /**
         * Metodo para manejar evento de datepicker fecha inicial. 
         * verifica si la fecha de inicio es menor para actualizar el valor de fecha
         * final dinamicamente.
         */
        seleccionDeFechaDtPkInicio: function() {
            this.$nextTick(() => {
              //  let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
              let fechaInicio = this.obtenerFecha(this.contenido.FechaDePublicacion);
              let fechaFinal = this.obtenerFecha(this.fechaDatePickerfinal);
                if(fechaInicio > fechaFinal) {
                    this.fechaDatePickerfinal = this.fechaDatePickerInicio;
                    this.fechaDefaultDtPkFinal = this.fechaDatePickerInicio;
                }
            });
        },
        /**
         * Metodo para manejar evento de datepicker fecha inicial. 
         * En caso de no requerirse eliminar metodo
         */
        seleccionDeFechaDtPkFin: function() {
           // de momento no hay logica aqui utilizar despues
        },




    agregarDatosParaContacto: function() {
              
        if(this.tituloContacto!=null && this.descripcionContacto!=null){
            
            if(!/\s+$/.test(this.tituloContacto) && !/\s+$/.test(this.descripcionContacto)){
            let objetoContacto = {};
          objetoContacto.id = (this.listaDeArchivos.length + 1);
          objetoContacto.Titulo = this.tituloContacto;
          objetoContacto.TextoDescripcion = this.descripcionContacto;
          if(this.EsLink){
              objetoContacto.TextoDescripcion="EsLink";
              objetoContacto.RutaDelArchivo = this.descripcionContacto;
          }
          this.listaDeArchivos.push(objetoContacto);
          this.tituloContacto=null;
          this.descripcionContacto=null;
          this.EsLink=false;
          $('#noEsLink').attr('checked',true);
            }else  comun.mensajeDeAlerta("Campos solo con espacios, favor de ingresar el tipo de contacto y la descripcion de contacto", null, null);

        }else comun.mensajeDeAlerta("Se detectaron campos vacíos, favor de ingresar el tipo de contacto y la descripcion de contacto", null, null);
        },
        /**
         * Metodo para agregar elemtos tipo archivo al listado que tendra el contenido que se dara de alta,
         * valida si el contenido requiere lista de archivos o solo un archivo.
         */
        agregarArchivosAcontenido: function() {
              if(this.listaDeArchivos.length == 1) {
                 comun.mensajeDeAlerta('Este contenido solo necesita un archivo o viculo a otra pagina ya has agregado uno,<br>Si deseas cambiar el archivo presione el icono de eliminar y repita el proceso para agregar un archivo o vinculo a otra pagina', null, null);
             }
             else {
                this.agregarArchivoEnListado();
             }
          
        },
        /**
         * Metodo encargado de construir objeto tipo archivo y posteriormente agregarlo al listado de archivos.
         */
        agregarArchivoEnListado: function() {
           
             let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
             let camposValidos = true;
             let identificadoresDeArchivo = this.identificardorTipoRutaArchivo();
            
             if(this.campoEsValidoFormulario(identificadoresDeArchivo.rutaDelArchivo)) {
                 let vinculoAotraPaginaEncontrado = this.existeVinculoAotraPagina();
                 if(identificadoresDeArchivo.nombreServidor == 'VinculoPrincipal' && vinculoAotraPaginaEncontrado.existe) {
                     comun.mensajeDeAlerta(`Solo se permite un vinculo a otra pagina y has agregado uno [${vinculoAotraPaginaEncontrado.nombreDelVinculo}], <br>Si deseas cambiar el vinculo a otra pagina presione el icono de eliminar y repita el proceso para agregar un vinculo a otra pagina`, null, null);
                 }  
                 else if( this.listaDeArchivos.length >= 1 && this.existeUnArchivoConEsteNombre(identificadoresDeArchivo.nombreBase,identificadoresDeArchivo.nombreServidor)) {
                     comun.mensajeDeAlerta('No se permiten archivos con el mismo nombre, <br>Cambia el nombre del archivo o elimina el que se encuentra en la lista', null, null);
                 }
                 else {
                     let objetoArchivo = {};            

                     objetoArchivo.NombreBase = identificadoresDeArchivo.nombreBase;             
                     objetoArchivo.NombreEnServidor = identificadoresDeArchivo.nombreServidor;
                     objetoArchivo.RutaDelArchivo = identificadoresDeArchivo.rutaDeArchivo;
                     objetoArchivo.Titulo = (this.campoEsValidoFormulario(this.tituloArchivo))? this.tituloArchivo : 'Sin título';
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.TextoDelVinculo = this.textoVinculoArchivo;
                     objetoArchivo.EsImagen = false;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = (this.campoEsValidoFormulario(this.textoVinculoArchivo))? this.textoVinculoArchivo : 'Sin texto de vínculo';                   
                    
                     this.listaDeArchivos.push(objetoArchivo);
                  
                     this.existePerdidaDeCambios = true;
                    
                     this.listaDeArchivosBit[objetoArchivo.RutaDelArchivo] = this.ARCHIVO_DESCARGA;
                     
                     this.contadorArchivos ++;
                   
                     this.limpiarApartadoArchivosFormulario();
                    
                     let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
                     
                   //  if(camposRequeridos.listaDeArchivos.requerido) {
                         comun.mensajeDeAlerta(`El ${this.textoBotonAgregaraAoV} se agregó correctamente`, null, null);
                     //}
                 }
               
             }
             
        },
  
      
        
        /**
         * Metodo encargado de identificar si se requiere subir archivo con vinculo o directamete desde el inpu
         */
        validarOpcionToggleArchivo: function() {
            let mostrar = true;
            // let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
            // if(!camposRequeridos.archivoConVinculo.requerido && this.descargaRadio) {
            //     mostrar = true;
            // }
            // else if(camposRequeridos.archivoConVinculo.requerido && descargaRadio && descargaArchivoRadio){
            //     mostrar = true;
            // }
            return mostrar;
        },
        /**
         * Metodo encargado de verificar si ya existe un vinculo a otra pagina en el listado
         * @returns {boolean} existeVinculoAotraPagina [variable que representa si ya existe el archivo o no]
         */
        existeVinculoAotraPagina: function() {
          
            let vinculoAotraPaginaEncontrado = {
                nombreDelVinculo: null,
                existe: false
            };
            if(this.listaDeArchivos.length > 0) {
                this.listaDeArchivos.filter(a => a.NombreEnServidor == 'VinculoPrincipal').forEach(archivo => {
                    vinculoAotraPaginaEncontrado.existe = true;
                    vinculoAotraPaginaEncontrado.nombreDelVinculo = archivo.NombreBase;
                });
            }
            return vinculoAotraPaginaEncontrado;
        },
         /**
         * Metodo encargado de verificar si ya existe un archivo con el mismo nombre 
         * @param {String} nombreDeArchivo [nombre del archivo a comparar]
         * @param {String} esVinculoOarchivo [indica si el elemento que se agregara al listado es vinculo a otra pagina, vinculo de archivo o archivo]
         * @returns {boolean} existeArchivo [variable que representa si ya existe el archivo o no]
         */
        existeUnArchivoConEsteNombre: function(nombreDeArchivo,esVinculoOarchivo) {
            let existeArchivo = false;
            if(this.listaDeArchivos.length > 0 && esVinculoOarchivo != 'VinculoPrincipal') {
                this.listaDeArchivos.filter(a => a.NombreBase == nombreDeArchivo && a.NombreEnServidor != 'VinculoPrincipal').forEach(archivo => {
                    existeArchivo = true;
                });
            }
            return existeArchivo;
        },
        /**
         * Metodo encargado para clasificar si el usario desea cargar un archivos desde el fromulario o cargarlo desde un vinculo
         * para posteriormente contruir el objeto del archivo. 
         * @see {@link agregarArchivoEnListado}
         * @returns {object} identificadoresDeArchivo [objeto con la estructura de la entidad ArchivosDeContenido]
         */
        identificardorTipoRutaArchivo: function() {
      
            const nombreInicialTipoArchivo = 'Archivo';
            const nombreInicialTipoVinculo = 'Vinculo';
            const nombreInicialTipoVinculoPrincipal = 'VinculoPrincipal';
             let identificadoresDeArchivo = {};
            if(this.vinculoRadio) {
                
                this.textoVinculoPrincipal = this.vinculo;
                
                identificadoresDeArchivo.rutaDelArchivo = this.vinculo;
                identificadoresDeArchivo.nombreServidor = nombreInicialTipoVinculoPrincipal;
                identificadoresDeArchivo.mensajeError = 'No has ingresado ningún vinculo a otra pagina,<br>Debes ingresar un vinculo valido a otra pagina';
                identificadoresDeArchivo.nombreBase = this.vinculo;
            }
            else if (this.descargaRadio){
                if(this.vinculoArchivoRadio){
                    identificadoresDeArchivo.rutaDelArchivo = this.vinculo;
                    identificadoresDeArchivo.nombreServidor = nombreInicialTipoVinculo + this.contadorArchivos;
                    identificadoresDeArchivo.mensajeError = 'No has ingresado ningún vinculo para el archivo,<br>Debes ingresar un vinculo para poder agregar el archivo';
                    identificadoresDeArchivo.nombreBase = this.vinculo;
                }
                 else {
                     identificadoresDeArchivo.rutaDelArchivo = this.ARCHIVO_DESCARGA;
                     identificadoresDeArchivo.nombreServidor = nombreInicialTipoArchivo + this.contadorArchivos;
                     identificadoresDeArchivo.mensajeError = 'No hay ningún archivo seleccionado,<br>Debes tener un archivo seleccionado para poder agregar el archivo';
                     identificadoresDeArchivo.nombreBase = this.campoEsValidoFormulario(this.ARCHIVO_DESCARGA) ? this.ARCHIVO_DESCARGA.name : null;
                 }
            }
            return identificadoresDeArchivo;
        },
         /**
         * Metodo encargado para limpiar las variables relacionadas con el apartado de archivos dentro del fromulario.  
         */
        limpiarApartadoArchivosFormulario: function() {
                  $("#descarga_contenido").val('');
                  this.ARCHIVO_DESCARGA = null;
                  this.tituloArchivo = null;
                  this.vinculo = null;
                  this.textoVinculoArchivo = null;
             
        },
         /**
         * Metodo encargado de remover items de la lista de archivos.
         * @param {object} evento [evento emitido por el icono de eliminar dentro de la tabla correspondiente al listado de archivos]
         */
        removerArchivoDeLista: function(evento) {
            
            let llaveArchivo = evento.target.getAttribute('id');
            const indexDeElemento = this.listaDeArchivos.findIndex(archivo => archivo.NombreEnServidor == llaveArchivo);
            if(indexDeElemento > -1) {
                this.listaDeArchivos.splice(indexDeElemento, 1);
                delete this.listaDeArchivosBit[llaveArchivo];
                if(this.listaDeArchivos.length < 1){
                    this.existePerdidaDeCambios = false;
                }
            }
        },
         /**
         * Metodo encargado de remover todos los items de la lista de archivo y reiniciar el contador.
         */
        vaciarListaArchivosAgregados: function() {
            this.listaDeArchivos = [];
            this.contadorArchivos = 0;
            this.listaDeArchivosBit = new Object();
            this.existePerdidaDeCambios = false;
        },
        /**
         * Metodo encargado de regresar al paso uno, validando previamente si el usuario no a guardado cambios dentro del formulario y
         * llamando al API para cambiar el estatus enEdicion de la saccion a false (no se esta editando).
         */
        cambioDeSeccion: function() {
           this.validarFormulario(null);
            if(this.existePerdidaDeCambios && this.modificoOrdenDeContenidos)
            {
                this.informarPerdidaDeCambiosEnFormularioYOrden();
            }
            else if(this.existePerdidaDeCambios || this.listaDeArchivos.length > 0) 
            {
                this.informarPerdidaDeCambiosFormularioContenido();
            }
            else if(this.modificoOrdenDeContenidos)
            {
                this.informarPerdidaDeCambiosOrdenContenidos(false);
            }
            else 
            {
                this.cambiarEstatusSeccion();
            }
        },
        /**
         * Metodo encargado de ocultar componente correspondiente al paso dos.
         */
        ocultarPasoDos: function() {
            $("#contenedor-pasoUno").removeClass("desabilitar-div-pasoUno");
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",false);
            this.limpiarFormulario();
        },
        /**
         * Metodo encargado validar si el contenido requiere textoDelVinculo.
         * @returns {boolean} mostrar [variable que representa si se debe mostrar el campo dentro del formulario]
         */
        mostrarTextoDelVinculo: function() {
            let mostrar = true;
             const PAGINA_WEB_CONVOCATORIA = 3;
             const PAGINA_WEB_BOLETIN_ELECTRONICO = 29;
            return mostrar;
        },
         /**
         * Metodo encargado de agregar contenido en base de datos valida previamente la existencia de perdida de cambios
         * en la pestaña Modificar orden del contenido. 
         * @see {@link informarPerdidaDeCambiosOrdenContenidos}
         * @see {@link agregarContenidoBD}
         */
        agregarContenido: function() {
            if(this.modificoOrdenDeContenidos){
                this.informarPerdidaDeCambiosOrdenContenidos(true);
            }else{
                this.agregarContenidoBD();
            }
        },

        editarMenuMicrositio:function(){
             comun.SeEstaCargandoInformacion(false);
           //  comun.mensajeDeAlerta("Se a Editado Correctamente", null, null);
              const SERVIDOR = api.conexion;             
                      const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.edicioncontenidomicrositio.EditarContenidoDeMicrositio;
                      let llaveArchivo = (this.ARCHIVO_DESCARGA != null) ?'ARCHIVO-MENU':null;
                     let urlApi = (!this.menuMicrositio.EsNuevo)?SERVIDOR + api.SICPO.sistema.paginaweb.administracionDeMenus.ModificarMenuPW :
                     SERVIDOR+api.sistema.paginaweb.administracionDeMenus.AgregarNuevoMenuPW;
                     //"SICPO/AdministracionDeMenusPW/AgregarNuevoMenu";
                   //  "SICPO/AdministracionDeMenusPW/ModificarMenu"
                      let peticion = new FormData();
                      let menuObjeto = {};
                      menuObjeto.RutaParaAccesar = (this.menuEsDescarga ==false)?this.menuRutaVinculoPagina: llaveArchivo;
                      menuObjeto.RutaParaAccesar = (menuObjeto.RutaParaAccesar==null)?this.menuMicrositio.RutaParaAccesar:menuObjeto.RutaParaAccesar;
                       menuObjeto.MenuId =(this.menuMicrositio.EsNuevo==true)?-1:this.menuMicrositio.MenuId;
           menuObjeto.ConSubmenus = this.menuConSubmenus;
            menuObjeto.AbrirEnVisor = this.visualizarEnVisor
            menuObjeto.Titulo =  this.menuTitulo;
            menuObjeto.EsDescarga = this.menuEsDescarga; // representa el valor de esDescarga y menuEspecial
            menuObjeto.Activo = true;
            menuObjeto.OrdenDelMenu -1;
            menuObjeto.EsMenuEspecial = false;
            menuObjeto.ElMenuParpadea = false;
             menuObjeto.PaginaDeInicio =(this.menuMicrositio.EsNuevo==true) ?{ PaginaDeInicioId: this.nuevoMenuMicrositio.MicrositioId, Activo: true }:{ PaginaDeInicioId: this.menuMicrositio.PaginaDeInicio, Activo: true };         
            menuObjeto.TipoPosicion=(this.menuMicrositio.EsNuevo==true)?{TipoPosicionId:this.nuevoMenuMicrositio.TipoMenu,Activo: true}:{TipoPosicionId:this.menuMicrositio.TipoPosicion.TipoPosicionId,Activo: true};
            peticion.append("ARCHIVO-MENU",this.ARCHIVO_DESCARGA);
            peticion.append('ReferenciaArchivo', 'ARCHIVO-MENU');
            peticion.append('Menu', JSON.stringify(menuObjeto));
             peticion.append('ActualizarOrdenDeMenu', false);
            peticion.append('EsPrueba', false);
                       let peticionArchivos = true;
                       let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
                       comun.SeEstaCargandoInformacion(false);
                        axios.post(urlApi, peticion, headerPeticion)
                                .then(respuesta => {            
                                    if (respuesta.data.SiHayError) {                                                      
                                        let mensajeError = respuesta.data.Error.Mensaje;
                                    } else {
                                        this.evtOcultaFormulario(true);
                                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                                    }
                                    comun.SeEstaCargandoInformacion(false);
                                })
                                .catch(excepcion => {
                                    comun.SeEstaCargandoInformacion(false);
                                    console.log(excepcion);
                                } 
                        );  

        },
         /**
         * Metodo encargado de llamar a la API para guardar contenido en base de datos. 
         */
        agregarContenidoBD: function() {
//  $("#ordenar-tab").removeClass("disabled")

             let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
             let validaVinculo = true;

if(camposRequeridos.RutaDeVideoRequerido && this.rutaVideo!=""){
if(this.rutaVideo!=null && !this.validarVinculoURL(this.rutaVideo) ) validaVinculo= false;

} 

             if(this.validarFormulario() && validaVinculo) {
                          
                      const SERVIDOR = api.conexion;             
                      const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.edicioncontenidomicrositio.EditarContenidoDeMicrositio;
                    
                     let urlApi = SERVIDOR + METODO_API_AGREGAR;
                     
                      let peticionAPI = this.crearPeticion();

                       let peticionArchivos = true;
                       let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
                       comun.SeEstaCargandoInformacion(false);
                        axios.post(urlApi, peticionAPI, headerPeticion)
                                .then(respuesta => {            
                                    if (respuesta.data.SiHayError) {                                                      
                                        let mensajeError = respuesta.data.Error.Mensaje;
                                        this.informarError(mensajeError);
                                    } else {
                                        this.limpiarFormulario();
                                        this.obtenerListadoDeContenidos();
                                        this.mostrarErroresInput = false;
                                        $("#ordenar-tab").removeClass("disabled");
                                        this.$emit('ocultarTooltip','disable');
                                        this.sobreescribirArchivo = false;
                                        this.evtOcultaFormulario();
                                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                                    }
                                    comun.SeEstaCargandoInformacion(false);
                                })
                                .catch(excepcion => {
                                    comun.SeEstaCargandoInformacion(false);
                                    console.log(excepcion);
                                    this.informarError(excepcion.message);
                                } 
                        );  
                  
             }
              else {
                 if(validaVinculo) comun.mensajeDeAlerta(this.textoMensajeCampoFaltante, null, null);
                  this.mostrarErroresInput = true;
                   this.textoMensajeCampoFaltante = '';
              }
        },
        /**
         * Metodo hacer el llamado a API para cambiar el estatus de la sección. 
         * @param {bool} enEdicion [estatus de seccion]
         */
        cambiarEstatusSeccion:function(){         
                                this.ocultarPasoDos();                    
        },
         /**
         * Metodo encargado para clasificar errores arrojados por excepciones y posteriormente informarlo al usuario. 
         * @param {String} error [mensaje de la excepcion capturada]
         */
        informarError: function(error) {
            switch(error){
                case 'Network Error':
                    this.manejoErrorArchivoNoEncontrado();
                    break;
                case 'Ya existe el archivo de descarga seleccionado':
                    this.informarSobreescrituraDeArchivos(error);
                    break;
                case 'Ya existe la imagen del comunicado seleccionada':
                    this.informarSobreescrituraDeArchivos(error);
                    break;
                default:
                    comun.mensajeDeAlerta(error, null, null);
                    break;
            }
        },
         /**
         * Metodo encargado para manejar el error FileNotFound en navegador. 
         */
        manejoErrorArchivoNoEncontrado: function() {
            const mensajeErrorImagen = 'Recurso no encontrado por favor verifique los campos imagen del contenido y archivo de descarga';
            const mensajeErrorArchivoDescarga = 'Recurso archivo de descarga no encontrado por favor verifique el campo';
            if(this.obtenerCamposRequeridosEnFormulario.RequiereCamposDeComunicado) {
                comun.mensajeDeAlerta(mensajeErrorImagen, null, null);  
            }
            else {
                comun.mensajeDeAlerta(mensajeErrorArchivoDescarga, null, null);
            }
        },
         /**
         * Metodo encargado para asignar valor de input correspondiente a la imagen a la variable IMAGEN_CONTENIDO que 
         * posteriormente se enviara en la peticon para el alta de contenido. 
         * @param {object} evento [evento emitido por el input tipo file correspondiente a la imagen]
         */
        subirImagen: function(evento) {
            try{
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'IMAGEN')) {
                        this.IMAGEN_CONTENIDO = evento.target.files[0];
                        this.mostrarSubidorDeArchivos = true;
                       
                    }
                    else {
                        $("#imagen_contenido").val('');
                        this.IMAGEN_CONTENIDO = null;
                        comun.mensajeDeAlerta('Para las imagenes solo se permiten extensiones JPEG,JPG y PNG,<br>Seleccione otra imagen con una de las siguientes extensiones JPEG,JPG o PNG');
                    }
                }
                else {
                    this.IMAGEN_CONTENIDO = null;
                    this.mostrarSubidorDeArchivos = false; 
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },

   
         /**
         * Metodo encargado para asignar valor de input correspondiente para archivo hacia la variable ARCHIVO_DESCARGA que 
         * posteriormente se enviara en la peticon para el alta de contenido. 
         * @param {object} evento [evento emitido por el input tipo file correspondiente al archivo]
         */
        subirArchivoDescarga: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'DESCARGA')) {
                        this.ARCHIVO_DESCARGA = evento.target.files[0];
                        this.mostrarSubidorDeArchivos = true;
                    }
                    else {
                        $("#descarga_contenido").val('');
                        this.ARCHIVO_DESCARGA = null;
                        comun.mensajeDeAlerta('Para los archivos de descarga solo se permiten extensiones PDF,XLSX,XLSB y ZIP,<br>Seleccione otro archivo con una de las siguientes extensiones PDF,XLSX,XLSB o ZIP');
                    }
                }
                else {
                    this.ARCHIVO_DESCARGA = null;
                    this.mostrarSubidorDeArchivos = false;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        verificaQueSeaElDocumentoCorrecto: function(nombreArchivo,tipoDocumento) {
            const NOMBRE_CORTADO = nombreArchivo.split(".");
            let siEsUnDocumentoValido = false;
            switch(tipoDocumento) {
                case 'DESCARGA':
                    const EXTENSION_ARCHIVO = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_ARCHIVO === 'PDF' || EXTENSION_ARCHIVO === 'XLSX' || EXTENSION_ARCHIVO === 'XLSB' || EXTENSION_ARCHIVO === 'ZIP')
                        siEsUnDocumentoValido = true;

                    break;
                case 'IMAGEN':
                    const EXTENSION_IMAGEN = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_IMAGEN === 'JPEG' || EXTENSION_IMAGEN === 'JPG' || EXTENSION_IMAGEN === 'PNG')
                        siEsUnDocumentoValido = true;
                        
                    break;
                default:
            }
            return siEsUnDocumentoValido;
        },
       
        transformarImagenesPredeterminadasParaCatalogo: function(listaImagenes) {
            let ListadoImagenesPredeterminadas = [];
            if(listaImagenes != null && listaImagenes.length > 0) {
                listaImagenes.forEach((img)=>{
                    let objImg = {
                        llave: img.ImagenPredeterminadaId,
                        imagen: img.RutaDeLaImagen
                    }
                    ListadoImagenesPredeterminadas.push(objImg);
                });
            }
            return ListadoImagenesPredeterminadas;
        },
         /**
         * Metodo encargado de crear la peticion para el alta de contenido, haciendo una iterando la lisa de archivos
         * para enviarlos como parametros independientes posteriormente se agrega a un objeto con la estructura de la
         * entidad de contenido finalmente se convierte el objeto contenido a JSON y se agrega como parametro. 
         */
        crearPeticion: function() {

           let datosDelFormulario = new FormData();
            let seccionId = this.$store.getters.Get_SICPO_Catalogo_014SeccionMicrositio.catalogoSeccionPasoUno;
            let contenidoIdMicrositio  = this.contenido.ContenidoDeMicrositioId;
            let paginaInicio = this.$store.getters.Get_SICPO_Catalogos_001PaginaInicio.catalogoPaginaPasoUno;
            let conArchivosContenido = false;//this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario.tipoDeFormulario == 'comunicado'? true : false;
            let formato = this.$store.getters.Get_SICPO_Catalogo_FormatoDeSeccion.valor;
            let conArchivo = false;
            let esCarrusel = false;
            let esTabla = false;
            let esContacto = false;
            let contenido = {};
           
            contenido.TextoDelContenido =  this.textoDelContenido;//this.construirDescripcionContenido(paginaId,esSeccion);
            contenido.TextoDelVinculo = this.textoVinculo;
            contenido.FechaDePublicacion = this.fechaDatePickerInicio;
            contenido.AbrirEnVisor = this.visualizarEnVisor;

            let llaveImagen = this.IMAGEN_CONTENIDO !=null ? 'Imagen': this.imagenDeObligacion;
            contenido.RutaDeImagen = llaveImagen;

            let llaveArchivo = this.ARCHIVO_DESCARGA ?'ArchivoDescarga':null;
            contenido.RutaDeArchivo = llaveArchivo;

if(formato==18){
    contenido.TextoDelVinculo=this.textoVinculoArchivo;
    contenido.TamanoDeLaColumna = 12;
}

            if(formato == 26){
                contenido.ArchivosDeContenidoMicrositios = this.listaDeArchivos;
                contenido.TextoDelContenido = this.titulo;
                contenido.TamanoDeLaColumna = 6;
                this.esComunicado=false;         
            }
            if(formato == 8){
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                contenido.TamanoDeLaColumna = 6;
                conArchivo = true;
                this.esComunicado=false;
                if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                }
            }

            if(formato == 16){
                contenido.TamanoDeLaColumna = 12;
                conArchivo = true;
                this.esComunicado=false;
               
               if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }

             if(formato == 19){
                contenido.TamanoDeLaColumna = 4;
                conArchivo = true;
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                this.esComunicado=false;

                 if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }

             if(formato == 20){
                contenido.TamanoDeLaColumna = 4;
                conArchivo = true;
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                this.esComunicado=false;
                if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }

            if(formato == 21){
                contenido.TamanoDeLaColumna = 7;
                conArchivo = true;
                contenido.TextoDelContenido = this.titulo + '|'+this.textoDelContenido;
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                this.esComunicado=false;

                if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }

            if(formato == 24){
                contenido.TamanoDeLaColumna = 12;
                this.esComunicado=false;
            }

            if(formato == 25){
                contenido.TamanoDeLaColumna = 12;
                this.esComunicado=false;
            }
            if(formato == 28){
                contenido.TamanoDeLaColumna = 12;
                conArchivo = true;
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                this.esComunicado=false;
                if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }
            if(formato == 30){
                let numColumnas = this.numeroDeColumnas.length;
                let textoFinal='';

                for(var aux=0; aux< numColumnas;aux++)
                    textoFinal = textoFinal.concat(this.numeroDeColumnas[aux],'|');

                contenido.TextoDelContenido = textoFinal.slice(0,-1);
                contenido.TamanoDeLaColumna = 12;
                this.esComunicado=false;
            }

            contenido.Activo = true;
         
            


             if(formato == 17){
                contenido.RutaDeArchivo = this.rutaVideo;
                 contenido.TamanoDeLaColumna = 12;
                 this.esComunicado=false;
            }

            if(formato == 27){
                contenido.ArchivosDeContenidoMicrositios = this.listaDeArchivos;         
                contenido.RutaDeArchivo = this.rutaVinculo;
                contenido.TextoDelContenido = this.titulo;
                contenido.TamanoDeLaColumna = 7;
                this.esComunicado=false;
                esContacto =true;
            }

            if(formato == 32){
                
                this.listaDeArchivos = [];

                 let objetoArchivo = {};
                     objetoArchivo.ContenidoDeMicrositioId = parseInt(this.$store.getters.Get_SICPO_Catalogo_015ContenidoMicrositio.contenidoMicrositioId);
                  //   if(IMAGEN_CONTENIDO != null){
                   //  objetoArchivo.NombreBase = this.IMAGEN_CONTENIDO.name;             
                   //  objetoArchivo.NombreEnServidor = this.IMAGEN_CONTENIDO.name;
                   //  }
                      objetoArchivo.NombreBase =(this.IMAGEN_CONTENIDO!=null)?this.IMAGEN_CONTENIDO.name:null;             
                     objetoArchivo.NombreEnServidor = (this.IMAGEN_CONTENIDO!=null)?this.IMAGEN_CONTENIDO.name:null;
                     objetoArchivo.RutaDelArchivo = llaveImagen;
                     objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivoDeContenidoMicrositioId;
                     objetoArchivo.Titulo = this.tituloCarrusel;
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.EsImagen = true;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = this.textoDelContenido;
                     objetoArchivo.AbrirEnVisor = false;                   
                     this.listaDeArchivos.push(objetoArchivo);                 
                     esCarrusel = true
                     contenido.TamanoDeLaColumna = 12;
                     this.esComunicado=false;
            }


             if(formato == 29 || formato == 22){
                 let objetoArchivo = {};
                 let objetoComunicado = {};
                     //objetoArchivo.ContenidoDeMicrositioId = parseInt(this.$store.getters.Get_SICPO_Catalogo_015ContenidoMicrositio.contenidoMicrositioId);
                     objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivosDeContenidoMicrositios[0].ArchivoDeContenidoMicrositioId;
                     objetoArchivo.NombreBase = (this.ARCHIVO_DESCARGA!="" && this.ARCHIVO_DESCARGA!=null)?this.ARCHIVO_DESCARGA.name:"";             
                     objetoArchivo.NombreEnServidor = (this.ARCHIVO_DESCARGA!="" && this.ARCHIVO_DESCARGA!=null)?this.ARCHIVO_DESCARGA.name:"";
                     objetoArchivo.RutaDelArchivo = llaveArchivo;
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     //objetoArchivo.TextoDelVinculo = this.textoVinculoArchivo;
                     objetoArchivo.EsImagen = false;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = this.textoVinculoArchivo;
                     objetoArchivo.AbrirEnVisor = this.visualizarEnVisor;                   
                     this.listaDeArchivos.push(objetoArchivo);
                    if(formato == 22){
                        let numColumnas = this.numeroDeColumnas.length;
                        let textoFinal='';

                        for(var aux=0; aux< numColumnas;aux++)
                                textoFinal = textoFinal.concat(this.numeroDeColumnas[aux],'|');
                                contenido.TextoDelContenido = textoFinal.slice(0,-1);
                    }

                     if(this.esComunicado){
                         objetoComunicado.Titulo=this.tituloComunicado;
                         objetoComunicado.FechaPublicacion = this.fechaDatePickerInicio;
                         objetoComunicado.PaginaInicioId = paginaInicio;
                         objetoComunicado.Activo = this.esComunicado
                         
                     }

                contenido.ComunicadosMicrositios = objetoComunicado;

                conArchivosContenido=true;
                esCarrusel = false;
                esTabla=true;
                contenido.TamanoDeLaColumna = 12;
            }




            if(formato == 15){
                    this.listaDeArchivos = [];
                if(this.esImagen){
                     let objetoArchivo = {};               
                     objetoArchivo.ContenidoDeMicrositioId = parseInt(this.$store.getters.Get_SICPO_Catalogo_015ContenidoMicrositio.contenidoMicrositioId);
                     objetoArchivo.NombreBase = this.IMAGEN_CONTENIDO.name; 
                     objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivoDeContenidoMicrositioId;            
                     objetoArchivo.NombreEnServidor = this.IMAGEN_CONTENIDO.name;
                     objetoArchivo.RutaDelArchivo = llaveImagen;                 
                     objetoArchivo.Titulo = this.tituloCarrusel;
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.EsImagen = true;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = this.textoDelContenido;                   
                     objetoArchivo.AbrirEnVisor = false;  
                     this.listaDeArchivos.push(objetoArchivo);
                    
                  
                    esCarrusel = true
                    contenido.TamanoDeLaColumna = 12;
                    this.esComunicado=false;
                }
                else if(this.esTexto){
                     let objetoArchivo = {};          
                     
                     objetoArchivo.ContenidoDeMicrositioId = parseInt(this.$store.getters.Get_SICPO_Catalogo_015ContenidoMicrositio.contenidoMicrositioId);                             
                      objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivoDeContenidoMicrositioId;  
                     objetoArchivo.Titulo = this.tituloCarruselYTexto;
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.EsImagen = false;
                     objetoArchivo.Activo = true;
                     objetoArchivo.AbrirEnVisor = false;  
                     objetoArchivo.TextoDescripcion = this.textoDelContenidoCarrusel;                   
                    
                     this.listaDeArchivos.push(objetoArchivo);
                               
                    esCarrusel = true;
                    this.esComunicado=false;

                }
            }
           
 
            if(this.descargaRadio) {
                
                 this.listaDeArchivos = this.listaDeArchivos.filter(a => a.NombreEnServidor != 'VinculoPrincipal');
        
                 this.listaDeArchivos.filter(a => a.NombreEnServidor.includes('Archivo')).forEach(archivo => {
                
                    datosDelFormulario.append(archivo.NombreEnServidor,this.listaDeArchivosBit[archivo.NombreEnServidor]);
                     archivo.RutaDelArchivo = '';
                     archivo.Titulo = (archivo.Titulo == 'Sin título') ? null : archivo.Titulo;
                     archivo.TextoDelVinculo = (archivo.TextoDelVinculo == 'Sin texto de vínculo') ? null : archivo.TextoDelVinculo;
                 });
                 contenido.ArchivosDeContenidoMicrositios = this.listaDeArchivos;
             }
            if(this.IMAGEN_CONTENIDO !=null)
                datosDelFormulario.append(llaveImagen,this.IMAGEN_CONTENIDO);

                if(this.ARCHIVO_DESCARGA !=null)
                datosDelFormulario.append(llaveArchivo,this.ARCHIVO_DESCARGA);

            contenido.ArchivosDeContenidoMicrositios = this.listaDeArchivos;

             let contenidoJSON = JSON.stringify(contenido);
             datosDelFormulario.append('Contenido',contenidoJSON); 
             datosDelFormulario.append('ContenidoMicrositioId',contenidoIdMicrositio);
             datosDelFormulario.append('SeccionId',seccionId);
             datosDelFormulario.append('ConArchivosContenido', conArchivosContenido);
             datosDelFormulario.append('EsComunicado', this.esComunicado);
             datosDelFormulario.append('ConArchivo',conArchivo);
             datosDelFormulario.append('EsCarrusel',esCarrusel);
              datosDelFormulario.append('EsTabla',esTabla);
              datosDelFormulario.append('EsContacto',esContacto);
             datosDelFormulario.append('EsPrueba',false);
             datosDelFormulario.append('Formato',formato);
             let submenuId = (this.disposicionEspecial) ? this.$store.getters.Get_SICPO_Catalogos_006Submenus.catalogoSubmenusPasoDos : -1;
             datosDelFormulario.append('SubmenuId',submenuId);
             datosDelFormulario.append('SubmenuTitulo',this.textoTituloSubmenu);

    
            return datosDelFormulario;
        },
        
         /**
         * Metodo encargado de inicializar el formulario (limpiar los input y variables ralcionadas con logica de alta de contenido). 
         */
        inicializarFormulario: function() {
            this.limpiarFormulario();
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput",false);

        },
        /**
         * Metodo encargado de limpiar cada una de las variables relacionadas con el formulario de alta de contenido. 
         */
        limpiarFormulario: function() {
          
            this.titulo = '';
            this.vinculo = null;
            this.textoDelContenido = null;
            this.textoVinculo = null;

            this.tituloCarruselYTexto=null;
            this.textoDelContenidoCarrusel = null;
            this.rutaVinculo = null;
            this.tituloContacto = null;
            this.descripcionContacto = null;
            this.numeroDeColumnas = [null];
            this.tituloCarrusel = null;
            this.rutaVideo = null;
            this.vinculo = null;

            
            $("#imagen_contenido").val('');
            $("#descarga_contenido").val('');
             
            this.IMAGEN_CONTENIDO = null;
            this.ARCHIVO_DESCARGA = null;
           
            this.fechaDePublicacion = '';
            this.fechaDePublicacionFin = '';
           
            this.limpiarOpcionesToggle();

            if(this.urgenteRadio) {
                this.urgenteRadio = true;
                this.informativoRadio = false;
            }
            else {
                this.urgenteRadio = false;
                this.informativoRadio = true;
            }
          
            this.listaDeArchivos = [];
            this.contadorArchivos = 0;
           
            this.textoVinculoArchivo = null;
            this.nombrePresidente = null;
            
            this.rangoPresidente = null;

            this.vinculoArchivo = false;
            this.textoBotonAgregaraAoV = 'Archivo'
           
            this.textoVinculoPrincipal = null;
            this.disposicionEspecial = false;
           
            this.esPin = false;
            this.textoTituloSubmenu = null;
            this.tituloComunicado=null;
           
            this.fechaDatePickerInicio = new Date();
            this.fechaDatePickerfinal= new Date();
             
            $('#' + this.imagenDeObligacion).prop('checked', false);
            this.imagenDeObligacion = null;
            
            $("#catalogo-poderes-pasoDos option:first").prop("selected", "selected");
            
        },
        /**
         * Metodo encargado de reiniciar los valores para las opciones toggle correspondientes al manejo de archivos 
         * y vinculos a otras paginas
         */
        limpiarOpcionesToggle: function() {
            if(this.descargaRadio) {
                this.vinculoRadio = false;
                if(this.descargaArchivoRadio) {
                    this.vinculoArchivoRadio = false;
                }
                else if(this.vinculoArchivoRadio) {
                     this.descargaArchivoRadio = false;
                }
            }
            else if(this.vinculoRadio) {
                this.descargaRadio = false;
                this.descargaArchivoRadio = true;
                this.vinculoArchivoRadio = false;
            }
        },
        /**
         * Metodo encargado de actualizar y recuperar el valor de existePerdidaDeCambios.  
         * @returns {boolean} existePerdidaDeCambios [representa si el formulario tiene información o no]
         */
        obtenerExistePerdidaDeCambios: function()
        {
            this.validarFormulario(null);
            return this.existePerdidaDeCambios;
        },
        /**
         * Metodo encargado de validar que los campos requeridos por el formulario no estan vacion o contengan datos incorrectos.  
         * @param {any} tipoDeFormulario [indicador para clasificar el tipo de formulario]
         * @returns {boolean} formularioValido [representa si el formulario es valido o no]
         */
        validarFormulario: function() {
            
             let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
             let camposAvalidar = [];
             let formularioValido = true;
             let input = {};

            if(camposRequeridos.TextoDelContenidoRequerido) {
                 input = {
                      campo: this.textoDelContenido,
                     mensaje: 'la descripcion'
                 }
                 
                  camposAvalidar.push(input)
              }
            
        
            if(camposRequeridos.RutaDeVideoRequerido ) {
                
                 input = {
                      campo: this.rutaVideo,
                     mensaje: 'la ruta del video'
                 }
                  camposAvalidar.push(input)

        
              }


            if(camposRequeridos.FechaPublicacionRequerido) {
                 input = {
                      campo: this.fechaDatePickerInicio,
                     mensaje: 'la fecha de publicación'
                 }
                  camposAvalidar.push(input)
              }

                                                     
            if(camposRequeridos.RutaDeImagenRequerido) {
                
                 input = {
                      campo: this.IMAGEN_CONTENIDO,
                     mensaje: ' la imagen del contenido'
                   }
                  camposAvalidar.push(input);
              }

              if(camposRequeridos.SeleccionaImagenOTexto){
                  if(this.esImagen){
                      
                      input={
                          campo:this.IMAGEN_CONTENIDO,
                          mensaje:'la imagen del contenido'
                      }
                      camposAvalidar.push(input);
                  }
                  else if(this.esTexto){
                      input={
                          campo: this.textoDelContenidoCarrusel,
                          mensaje:'la descripcion del contenido'
                      }
                      camposAvalidar.push(input);
                  }


              }

            if(camposRequeridos.RutaDelArchivoRequerido) {
                if(this.descargaArchivoRadio){
                  input = {
                      campo: this.ARCHIVO_DESCARGA,
                      mensaje: 'el archivo de descarga'
                 }
                  camposAvalidar.push(input)
                }
                else if(this.vinculoArchivoRadio){
                     input = {
                      campo: this.vinculo,
                      mensaje: 'el vínculo del archivo o pagína'
                 }
                  camposAvalidar.push(input)

                }
              }

              if(camposRequeridos.TextoDelVinculoRequerido) {
                  input = {
                      campo: this.textoVinculoArchivo,
                      mensaje: 'el texto del vínculo'
                 }
                  camposAvalidar.push(input)
              }

              if(camposRequeridos.TituloDelContenidoRequerido) {
                  input = {
                      campo: this.titulo,
                      mensaje: 'el titulo'
                 }
                  camposAvalidar.push(input)
              }


             if(camposRequeridos.ListaContactosRequerido) {
                  input = {
                      campo: this.listaDeArchivos,
                      mensaje: 'algun dato de contacto'
                 }
                  camposAvalidar.push(input)
              }

              if(camposRequeridos.RutaVinculoRequerido) {
                  input = {
                      campo: this.rutaVinculo,
                      mensaje: 'el vinculo del mapa'
                 }
                  camposAvalidar.push(input)
              }

               if(camposRequeridos.TextoColumnasRequerido) {
                                  
                 input = {
                      campo: this.numeroDeColumnas,
                      mensaje: 'los campos de las columnas'
                 }
                  camposAvalidar.push(input)
              }

              if(camposRequeridos.TituloCarruselTextoRequerido) {
                                  
                 input = {
                      campo: this.tituloCarruselYTexto,
                      mensaje: 'el titulo'
                 }
                  camposAvalidar.push(input)
              }

               if(camposRequeridos.TextoDelContenidoCarruselRequerido) {
                   
                 input = {
                      campo: this.textoDelContenidoCarrusel,
                      mensaje: 'el texto'
                 }
                  camposAvalidar.push(input)
              }

             formularioValido = this.validarCamposFormulario(camposAvalidar);
            return formularioValido;
        },
        validacionesEspecificasParaInput: function() {
            let validacionesRealizadas = true;
            if(this.vinculoRadio){
                let vinculoValido = this.validarVinculoURL(this.vinculo);
                if(!vinculoValido)
                    return vinculoValido;
            }
            return validacionesRealizadas;
        },
        validarVinculoURL: function(vinculo) {
            let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocolo
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // nombre del dominio
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // ip
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // puerto y ruta
                '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query de la peticion
                '(\\#[-a-z\\d_]*)?$','i'); // localizador de fragmentos
            let vinculoValido = !!pattern.test(vinculo);
            if(!vinculoValido)
                comun.mensajeDeAlerta('El vinculo no es valido,<br> por favor ingrese un vinculo valido, ejemplo www.vinculoPrueba.com');

            return vinculoValido;
        },
        /**
         * Metodo encargado de obtener la fecha actual con el formato [yyyy-mm-dd]
         */
        obtenerFecha: function(fecha) {
            let fechaActual = fecha;
            let mes = '' + (fechaActual.getMonth() + 1);
            let dia = '' + fechaActual.getDate();
            let year = fechaActual.getFullYear();

            if (mes.length < 2) 
                mes = '0' + mes;
            if (dia.length < 2) 
                dia = '0' + dia;

            return [year, mes, dia].join('-');
        },
        /**
         * Metodo encargado de validar los input correspondientes a fechas
         * fecha de publicación inicial >= fecha actual &&  fecha de publicación inicial < fecha de publicación final
         * fecha de publicación final > fecha de publicación inicial && fecha de publicación final > fecha actual
         */
        validarFechas: function() {
            let fechaValida = false;
            let fechaActual = this.obtenerFecha(new Date());
            let mensajeError = ['La fecha de publicación inicial no puede ser menor a la fecha actual, <br> por favor ingrese una fecha de publicación inicial valida'];
            if(this.fechaDePublicacion >= fechaActual) {
                fechaValida = true;
                mensajeError.pop();
            }
            if(this.urgenteRadio) {
                if(fechaValida && this.fechaDePublicacion < this.fechaDePublicacionFin) {
                    if(this.fechaDePublicacionFin > fechaActual) {
                         fechaValida = true;
                    }
                    else {
                        fechaValida = false;
                        mensajeError.push('La fecha final de publicacion no puede ser menor a la fecha actual, <br> por favor ingrese una fecha final de publicacion valida');
                    }
                }
                else {
                    fechaValida = false;
                    mensajeError.push('La fecha de publicacion inicial no puede ser mayor o igual a la fecha fin de la publicacion, <br> por favor ingrese una fecha de publicacion inicial valida');
                }
            }

            if(!fechaValida){
                comun.mensajeDeAlerta(mensajeError[0]);
            }
            return fechaValida;
        },
        /**
         * Metodo encargado de iterar lista de campos requridos por el formulario para posteriormente validar cada uno de los valores.  
         * @param {array} datosFormulario [arreglo compuesto de los capos requeridos por el formulario]
         * @returns {boolean} camposValidos [indica si los elementos de la lista de campos requeridos son validos]
         */
        validarCamposFormulario: function(datosFormulario) {
            let camposValidos = true;
            let existeValorIncorrecto = false;
            this.existePerdidaDeCambios = false;
            for (let i=0; i<datosFormulario.length; i++ ) {
                if(!existeValorIncorrecto){
                    camposValidos = this.campoEsValido(datosFormulario[i]);
                    if(!camposValidos){
                        existeValorIncorrecto = true;
                    }
                    else{
                        this.existePerdidaDeCambios = true;
                    }
                }
                else {
                    let resultadoTemporal = this.campoEsValido(datosFormulario[i]);
                    this.existePerdidaDeCambios = resultadoTemporal ? resultadoTemporal : this.existePerdidaDeCambios;
                }
            }
            return camposValidos;
        },
         /**
         * Metodo encargado de comparar si un valor del formulario esta vacio y si es obligatorio se asigna el valor del
         * mensaje que se mostrara al ususario en base al orden de los campos previamente establecidos.  
         * @param {any} input [valor a comparar]
         * @returns {boolean} campoValido [indica si el valor comparado esta vacio o no]
         */
        campoEsValido: function(input) {
            let campoValido = true;
            if(input.campo == null || input.campo == undefined || input.campo == "" || /\s+$/.test(input.campo)) {
                campoValido = false;
                if(this.textoMensajeCampoFaltante =='')
                    this.textoMensajeCampoFaltante = 'Se detectaron campos vacios, favor de ingresar ' + input.mensaje + '.';
            
            }
            else if(this.textoMensajeCampoFaltante.includes(input.mensaje)) this.textoMensajeCampoFaltante = '';
            
            return campoValido;
        },
        /**
         * Metodo encargado de comparar si un valor esta vacio.  
         * @param {any} input [valor a comparar]
         * @returns {boolean} campoValido [indica si el valor comparado esta vacio o no]
         */
        campoEsValidoFormulario: function(input) {
            let campoValido = true;
            if(input == null || input == undefined || input == "") {
                campoValido = false;
            }
            return campoValido;
        },
        noHacerNada: function() {
            
        },
         /**
         * Metodo encargado de craer la peticion para obtener listado de contenidos de la base de datos.  
         * @returns {object} peticion [objeto con la estructura requerida para el consumo del metodo GET correspondiente del API]
         */
        crearPeticionListadoDeContenido: function() {
             let seccionId = this.$store.getters.Get_SICPO_Catalogo_014SeccionMicrositio.catalogoSeccionPasoUno;
            let paginaId  = this.$store.getters.Get_SICPO_Catalogos_013PaginaMicrositio.catalogoPaginaMicrositioPasoUno;
           
           //  let esComunicado = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario.tipoDeFormulario == 'comunicado'? true : false;
            let peticion = {
               // PaginaWebId: paginaId,
                SeccionMicrositioId: seccionId,
                EsPrueba:false
               // EsComunicado: esComunicado
            }
            return peticion;
        },
        /**
         * Metodo de lamar a la API para obtener listado de contenidos.  
         */
        obtenerListadoDeContenidos: function() {
            
            const SERVIDOR = api.conexion;         
            const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.altadecontenidomicrositio.ContenidosDeMicrositios;;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionAPI = this.crearPeticionListadoDeContenido();
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) { 
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        } else {
                          
                            let listaDeCotenidosOriginal = [];            
                            let contenidosDePaginaWeb    = respuesta.data.ContenidosDeMicrositio;
                            
                                this.ordenarDesc(contenidosDePaginaWeb,'contenido.OrdenDelContenido');
                             
                                listaDeCotenidosOriginal = contenidosDePaginaWeb;
                          
                            this.mapearInformacionParaListado(listaDeCotenidosOriginal);
                        }
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                    }
            ) // axios.post
        },

         ordenarAsc:function(p_array_json, p_key) {
                
                p_array_json.sort(function (a, b) {
                    return a[p_key] > b[p_key];
             });
                },
             ordenarDesc:function(p_array_json, p_key) {
                this.ordenarAsc(p_array_json, p_key); p_array_json.reverse(); 
                },
        /**
         * Metodo encargado de mapear el listado de contenidos obtenido por la API en un nuevo listado con la 
         * estructura requerida() para mostrar el listado en la pestaña modificar orden de contenido.
         * @see ListaOrdenableDeContenido.vue  
         * @param {array} listado [lista de contenidos]
         */
        mapearInformacionParaListado: function(listado) {
            
            let listaContenidosOriginal = [];
            var urgenteVisibleId = -1;
            let hoy = new Date();
            var j =0;
            for(var i=listado.length;i>0;i--){
            
                let elementoContenido = {
                     id: i, 
                     mostrarDescripcion:false, 
                     hover:false,
                     conIconoUrgenteVisible: false,
                     conIconoMostrarEnInicio: true,
                     contenido: listado[j]
                     
                 }
                 listaContenidosOriginal.push(elementoContenido);
                 j++;
             }
           
            this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal",listaContenidosOriginal);
         
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar  posible perdida de cambios. 
         * @param {bool} guardarContenido [Si se quiere guardar contenido o cambiar seccion]
         * @see {@link agregarContenidoDB}
         * @see {@link cambiarEstatusSeccion}
         */
        informarPerdidaDeCambiosOrdenContenidos: function (guardarContenido) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Se detectaron cambios en la pestaña 'Modificar Orden de Contenidos', si deseas continuar " + (guardarContenido? "y cambiar de sección " : "") + "se perderán los cambios que no han sido guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        if(guardarContenido)
                        {
                            this.agregarContenidoBD();
                            this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        }
                        else{
                            this.cambiarEstatusSeccion(false);
                            this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        }
                    }
                }
            });
        },
        /**
         * Metodo encargado de mostrar alerta bootbox para informar  posible perdida de cambios.
         * @see {@link cambiarEstatusSeccion}
         */
        informarPerdidaDeCambiosEnFormularioYOrden: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Has ingresado información en la pestaña de 'Agregar Contenido' y se detectaron cambios en la pestaña 'Modificar Orden de Contenidos', si deseas continuar y cambiar de sección se perderán los cambios que no fueron guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.cambiarEstatusSeccion(false);
                        this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para acerca de sobreescritura de archivos. 
         * @param {string} mensajeR [mensaje que se quiera mostrar en alert]
         */
        informarSobreescrituraDeArchivos: function (mensajeR) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: mensajeR + ",<br> ¿deseas sobreescribir el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.sobreescribirArchivo = true;
                        this.agregarContenidoBD();
                        this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se removera un elemento de la lista de archivos. 
         * @param {object} evento [evento emitido por el item de la tabla de archivos]
         */
        informarSacarArchivoDeLista: function(evento) {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se eliminara el archivo de la lista,<br>¿Estas seguro de eliminar el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.removerArchivoDeLista(evento);
                    }
                }
            });
        },



informarEliminarDatoDeLista: function(evento) {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se eliminara el archivo de la lista,<br>¿Estas seguro de eliminar el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.removerDatoDeLista(evento);
                    }
                }
            });
        },


         removerDatoDeLista: function(evento) {
            
            let llaveArchivo = evento.target.getAttribute('id');      
            const indexDeElemento = this.listaDeArchivos.findIndex(archivo => archivo.id == llaveArchivo);
            if(indexDeElemento > -1) {
                this.listaDeArchivos.splice(indexDeElemento, 1);
                delete this.listaDeArchivosBit[llaveArchivo];
                if(this.listaDeArchivos.length < 1){
                    this.existePerdidaDeCambios = false;
                }
            }
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se agrego un elemento a la lista de archivos. 
         */
        informarVaciarListaDeArchivosAgregados: function() {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se eliminaran todos los archivos,<br>¿Estas seguro de eliminar todos los archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.vaciarListaArchivosAgregados();
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que existe la posibilidad de perdida de cambios.
         * @see {@link cambiarEstatusSeccion} 
         */
        informarPerdidaDeCambiosFormularioContenido: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Has ingresado información en la pestaña de 'Agregar Contenido', si deseas continuar y cambiar de sección se perderán los cambios que no han sido guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                         this.cambiarEstatusSeccion(false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se vaciara la lista de archivos (en caso de manejar listado y cambiar de opcion toggle vinculo a otra pagina)
         */
        informarVaciarListaDeArchivos: function() {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Si cambias a la opcion vinculo a otra pagina se borraran los archivos que has agregado,<br>¿Estas seguro de cambiar a la opcion vinculo a otra pagina?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.listaDeArchivos = [];
                        this.vinculoRadio=true;
                        this.descargaRadio=false;
                        this.vinculo=null;
                        this.textoBotonAgregaraAoV = 'Vinculo';
                    }
                    else {
                        $("#vinculoRadio-toggle").removeClass('active');
                        $("#descargaRadio-toggle").addClass('active');
                    }
                }
            });
        },

        informarCamposDeListaDeContactoEstanVacios: function() {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se detectaron campos vacios, favor de ingresar el tipo de contacto y/o descripcion de contacto",
                buttons: {                
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                   
                }
            });
        },
        acomodaMenuEnFormulario:function(){
          this.menuEsDescarga=this.menuMicrositio.EsDescarga;
         // this.menuRutaParaAccesar=this.menuMicrositio.RutaParaAccesar;
          this.menuTitulo=this.menuMicrositio.Titulo;
          this.menuRutaVinculoPagina = (this.menuMicrositio.EsDescarga)?null:this.menuMicrositio.RutaParaAccesar;
          //this.menuRutaVinculoPagina=this.menuMicrositio.RutaParaAccesar;
          this.menuVinculo=this.menuMicrositio.RutaParaAccesar;
          this.menuConSubmenus=this.menuMicrositio.ConSubmenus;
          this.visualizarEnVisor = this.menuMicrositio.AbrirEnVisor;
          this.valorDefinidoMicrositio = parseInt(this.menuMicrositio.PaginaDeInicio);
          
          this.idDelModelo = this.menuMicrositio.TipoPosicion.TipoPosicionId;
          this.idKey = this.idKey + 1;
         


        
        },
        agregarNuevoMenu:function(){
              this.menuEsDescarga=false;
          this.menuTitulo=null;
          this.menuRutaVinculoPagina = null;
          //this.menuRutaVinculoPagina=this.menuMicrositio.RutaParaAccesar;
          this.menuVinculo=null;
          this.menuConSubmenus=true;
          this.visualizarEnVisor = false;
          //this.menuRutaParaAccesar
        }

    },
   
    mounted() {
            if(this.menuMicrositio.EsNuevo==true)this.agregarNuevoMenu();
            else this.acomodaMenuEnFormulario();
    },
    computed: {
        obtenerTipoDeFormulario() {
             return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_tipoDeFormulario;
        },
        mostrarErrorEnInput() {
            return this.mostrarErroresInput;
        },
        obtenerCambiarFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormulario;
        },
        obtenerInicializarFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormularioInput;
        },
        obtenerCamposRequeridosEnFormulario() {
        return this.$store.getters.Get_SICPO_Catalogo_TipoDeFormulario;
            
        },
        obtenerListadoInicial() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal;
        },
        modificoOrdenDeContenidos() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos;
        },
        obtenerPaginaWebId() {
            return this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
        },
        obtenerPunterosParaContenido() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual;
        },
        obtenerTituloDeSeccion(){
            return this.$store.getters.Get_SICPO_Catalogo_FormatoDeSeccion;
        }

    }
}
</script>
<style  scoped>
.imagen-actual{
    border-radius:22px;
    border:3px;
    width:80%;
    height:25em;
    margin-left:10%;
    margin-top: 1%; 
    margin-bottom: 1%;
}
.fuente-tabla{
    color:rgb(250, 250, 250);
}

    .container-btn {
        display: flex;                             
        justify-content: space-between; 
    }
    h5, h6{
        user-select: none;
    }
    .btn-group-toggle{
        margin-bottom: 1em;
    }
    .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
        color: white;
        background-color: #57585B;
        border-color: white;
    }
    .btn-secondary {
        color: rgb(106, 108, 112);
        background-color: #323335;
        border-color: rgb(106, 108, 112);
        font-size: 0.95rem;
    }
    .btn-secondary:hover {
        color: white;
        background-color: #323335;
        border-color: white;
    }
    .elementos-archivos-contenido {
         margin-top: 2%;
    }
    .elemento-lista-archivos {
        margin: 0;
    }
    .elemento-eliminar-archivo {
        cursor: pointer;
        margin-left: 4px;
    }
    .linea-vertical {
      width: 0px; /* Use only border style */
      height: 80%;  
      border: 1px inset; /* This is default border style for <hr> tag */
      margin-left: 6px;
    }
    .linea-horizontal {
        margin: 0;
    }
    .opciones-vaciar-listaDeArchivos {
        display: flex; 
        justify-content: flex-start;
    }

    .opcion-ver-listadoArchivos-agregados:hover {
        cursor: pointer;
    }

    .scroll-contenedor {
        height:200px;
        overflow:scroll;
        overflow-x:hidden;
    }

     .contenedor-listado-archivos {
        overflow-y: auto;
        max-height: 200px;
    }

    .contenedor-listado-archivos table {
        border-collapse: collapse;
        width: 100%;
        background-color: #26272b;
        
    }

    .contenedor-listado-archivos th {
        position: sticky;
        top: 0;
        background: #474749;
        border: 1;
    }
    .contenedor-puntero {
        background: #212529;
        border-radius:2px;
        padding: 10px;
        border:1px solid white;
        margin-bottom: 1.5em;
    }

    .contenedor-cambio-seccion {
       display: flex;
       justify-content: space-between;
    }

    .texto-negro {
        color: black;
    }

    .sin-margen-superior {
        margin-top: 0px;
    }



</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/Menu/CFormularioEdicionMenu.vue